import { render, staticRenderFns } from "./v-pagination.vue?vue&type=template&id=5dfc52f2&scoped=true&"
import script from "./v-pagination.vue?vue&type=script&lang=js&"
export * from "./v-pagination.vue?vue&type=script&lang=js&"
import style0 from "./v-pagination.vue?vue&type=style&index=0&id=5dfc52f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc52f2",
  null
  
)

export default component.exports